import styled from 'styled-components';

import { ACQ, COLORS } from '../../theme/tokens';
import { softCard, hoverWash } from '../../theme/mixins';
import { Text, StatGrid } from '../../components';

// --- page section stack + tab bar spacing -----------------------------------
export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TabsBar = styled.div`
  margin-top: 4px;
`;

// --- "Your Affiliates" header row -------------------------------------------
export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderTitle = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.heading};
`;

export const Count = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 600;
  background: ${COLORS.surfaceMuted};
  color: ${COLORS.textMuted};
`;

// --- "campaign table" container — wraps the filter row + the affiliate cards.
// Same surface as the Acquisition campaigns list (Figma "campaign table"): the
// #101012 outer card with a tight 4px gutter. ------
export const Panel = styled.div`
  background: ${ACQ.cardOuter};
  border-radius: 16px;
  padding: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// --- Affiliate cards --------------------------------------------------------
// Sits inside Panel; the 6px side/bottom inset gives the cards the same gutter
// the filter row's own 6px padding does (cards land ~10px off the container edge).
export const AffList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 6px 6px;
`;

export const AffCard = styled.div`
  ${softCard}
  ${hoverWash}
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  outline: none;
`;

export const AffTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const AffName = styled(Text)`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.heading};
`;

export const NoteRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

// --- Stats grid -------------------------------------------------------------
// Each stat sits in its own recessed tile (Figma "campaign table": a transparent
// dark box, 8px radius, 10px pad, packed in a tight 2px-gutter grid) so the row
// reads as a segmented panel rather than free-floating figures.
export const BoxedStatGrid = styled(StatGrid)`
  gap: 2px;
  & > * {
    background: ${COLORS.metricTileBg};
    border-radius: 8px;
    padding: 10px;
  }
`;
